import { del } from '../helpers/fetchSagaAPI';

export const deleteRatings = function* (soundcastId, ratingId, config = {}) {
  return yield del(`/api/rating/soundcast/${soundcastId}/${ratingId}`, { ...config });
};
